export const translations = {
  en: {
    nav: {
      home: 'HOME',
      about: 'ABOUT US',
      contact: 'CONTACT',
      cta: 'REQUEST CONSULTATION',
    },
    hero: {
      eyebrow: 'MINIMIZE RISK. ACCELERATE AGILITY.',
      title1: 'Zero Trust Architecture',
      title2: '& Complaint IAM for Azure environments.',
      subtitle: 'I D E N T I T Y   ·   A C C E S S   ·   G O V E R N A N C E',
      primary: 'EXPLORE SERVICES',
      secondary: 'ABOUT US',
    },
    pillars: {
      eyebrow: 'OUR CORE PRACTICE',
      title: 'Three pillars that define enterprise identity.',
      items: [
        {
          title: 'Smart Access Strategy',
          desc: 'Prevent data leaks and internal security threats by ensuring the right people have the right access—without slowing down your daily operations.',
        },
        {
          title: 'Secure Cloud Identity',
          desc: 'Migrate to the cloud safely and keep your remote workforce secure. Complete protection against unauthorized access, fully aligned with industry standards.',
        },
        {
          title: 'Compliance & Risk Advisory',
          desc: 'Protect your business from costly regulatory fines and security audits. We streamline your compliance (NIS2, GDPR) so you can focus on growing your business with peace of mind.',
        },
      ],
    },
    bridge: {
      eyebrow: 'THE HIGH COST OF MANUAL ACCESS',
      lead: 'Managing user access manually wastes valuable business hours. Delays in granting access slow your team down, while delayed offboarding leaves your company exposed to costly data breaches and heavy fines.',
      body: 'At Pezente Digital, we turn complex access control into a simple, automated system. We cut employee onboarding time from days to minutes—keeping your workforce productive, your systems compliant, and your profit margins protected.',
      highlight: 'Pure security. Zero friction. Technology that drives your business forward.',
    },
    threeSteps: {
      eyebrow: 'A CLEAR PATH',
      title: 'Protect your business without slowing down operations. Choose your Safe-Identity method.',
      cards: [
        {
          name: 'Identity Retainer (Basic Plan)',
          steps: [
            {
              title: 'Continuous Monitoring',
              desc: 'We regularly check the status of your tenant (Entra ID) to identify anomalies and risks before they become incidents.',
            },
            {
              title: 'Agile Access Management',
              desc: 'We make targeted privilege adjustments and ensure immediate revocation for former employees, without disrupting your operations.',
            },
            {
              title: 'Compliance Maintenance',
              desc: 'All administration is carried out via an isolated remote environment, keeping your company protected and aligned with baseline security rules.',
            },
          ],
        },
        {
          name: 'Zero Trust Blueprint (Premium Plan)',
          steps: [
            {
              title: 'Access Assessment',
              desc: "We map your current vulnerabilities and access bottlenecks behind the scenes, with zero disruption to your team's daily routines.",
            },
            {
              title: 'Seamless Automation',
              desc: 'We implement intelligent access controls and governance. Identity security acts as a silent bodyguard, protecting your data while eliminating manual delays.',
            },
            {
              title: 'Total Productivity & Compliance',
              desc: 'Your team gets to work immediately, your margins are protected from breaches, and your business is audit-ready.',
            },
          ],
        },
      ],
      bookingCta: 'Book a free 30-minute IAM Risk Briefing',
    },
    portfolioCta: {
      eyebrow: 'A Different Lens',
      headline: 'Identity looks different from the boardroom.',
      body: 'Are you approaching identity from an HR or executive leadership perspective? Explore how the Safe-Identity Method connects identity architecture with compliance, operational resilience and business priorities.',
      cta: 'Explore the method',
      dashboardAlt: 'Entra ID identity governance dashboard',
      dashboardLabel: '[ Illustrative concept: Executive Identity & Compliance Dashboard ]',
    },
    about: {
      eyebrow: 'ABOUT US',
      body: 'Backed by over a decade of federal compliance expertise, Pezente Digital is the strategic partner specialized in IAM (Identity and Access Management) for Azure, helping enterprises navigate strict GDPR/NIS2 regulations. We understand the financial risks that over-privileged accounts and manual governance pose to your operations. As your dedicated guide, we restructure your access roles and enforce surgical Just-In-Time (JIT) policies, shielding your data from costly vulnerabilities without slowing down your business.',
      subtitle: 'Zero Trust Identity Architecture for critical organizations.',
      note: 'We transform your Azure environment into a secure identity fortress, delivering European market compliance backed by industry-leading security credentials.',
    },
    contact: {
      eyebrow: 'CONTACT',
      title: "Let's architect your Azure identity.",
      body: 'Contact us to schedule a confidential consulting session. We prioritize your identity security.',
      orWrite: 'OR WRITE TO',
      region: 'EUROPE',
      practice: 'Advisory Practice \u2014 EU / EMEA',
      form: {
        name: 'FULL NAME',
        email: 'PROFESSIONAL E-MAIL',
        company: 'COMPANY',
        subject: 'SUBJECT',
        message: 'HOW CAN WE HELP?',
        required: '* Required. We reply within two business days.',
        submit: 'SEND MESSAGE',
        toastOk: 'Message sent successfully.',
        toastDesc: 'We will respond within two business days.',
        consentText: 'I consent to the processing of my personal data in accordance with the',
        consentLinkText: 'Privacy Policy',
      },
    },
    footer: {
      tagline: 'Architect Identity. Ensure Digital Trust.',
      nav: 'NAVIGATION',
      contact: 'CONTACT',
      home: 'Home',
      about: 'About Us',
      contactLink: 'Contact',
      advisory: 'EU / EMEA Advisory',
      billing: 'Billing & Invoicing',
      rights: 'All rights reserved.',
      privacy: 'Privacy',
      terms: 'Terms',
      cookiePreferences: 'Cookie Preferences',
    },
    cookies: {
      message: 'We use cookies to improve your experience. Non-essential cookies (such as analytics) are only loaded after you accept. Read our',
      policyLinkText: 'Privacy Policy',
      accept: 'Accept',
      reject: 'Reject',
    },
  },
  pt: {
    nav: {
      home: 'IN\u00CDCIO',
      about: 'SOBRE N\u00D3S',
      contact: 'CONTACTO',
      cta: 'SOLICITAR CONSULTORIA',
    },
    hero: {
      eyebrow: 'MINIMIZE O RISCO. ACELERE A AGILIDADE.',
      title1: 'Arquitetura Zero Trust',
      title2: 'e IAM em Conformidade para ambientes Azure.',
      subtitle: 'I D E N T I D A D E   ·   A C E S S O   ·   G O V E R N A N Ç A',
      primary: 'EXPLORAR SERVI\u00C7OS',
      secondary: 'SOBRE N\u00D3S',
    },
    pillars: {
      eyebrow: 'A NOSSA PR\u00C1TICA CENTRAL',
      title: 'Tr\u00EAs pilares que definem a identidade empresarial.',
      items: [
        {
          title: 'Gestão Estratégica de Acessos',
          desc: 'Garantimos que cada funcionário acesse apenas o que precisa. Elimine o risco de vazamentos de dados e acessos indevidos sem travar a rotina da sua equipe.',
        },
        {
          title: 'Arquitetura de Identidade e Nuvem Segura',
          desc: 'Mova sua empresa para a nuvem com total segurança. Conecte sua equipa de onde estiver com proteção contra invasões e conformidade instantânea.',
        },
        {
          title: 'Consultoria em Conformidade & Blindagem Jurídica',
          desc: 'Livre sua empresa de multas milionárias e exigências regulatórias (LGPD, NIS2, GDPR). Esteja pronto para auditorias e passe total credibilidade para seus clientes.',
        },
      ],
    },
    bridge: {
      eyebrow: 'O ALTO CUSTO DO ACESSO MANUAL',
      lead: 'Gestão manual de acessos custa caro: novos funcionários perdem dias esperando liberações para trabalhar, enquanto ex-funcionários que mantêm acessos ativos deixam sua empresa vulnerável a vazamentos e multas pesadas.',
      body: 'Na Pezente Digital, nós automatizamos a segurança da sua empresa para que você não precise se preocupar com ela. Reduzimos o tempo de liberação de acessos de dias para minutos. Sua equipa produz desde o primeiro dia, sua empresa fica protegida e o seu lucro permanece seguro.',
      highlight: 'Segurança inteligente trabalhando pelo seu negócio.',
    },
    threeSteps: {
      eyebrow: 'UM CAMINHO CLARO',
      title: 'Proteja o seu negócio sem travar a operação. Escolha o seu método Safe-Identity.',
      cards: [
        {
          name: 'Gestão Contínua de Identidades (Plano Básico)',
          steps: [
            {
              title: 'Monitoramento Contínuo',
              desc: 'Verificamos o status do seu tenant (Entra ID) regularmente para identificar anomalias e riscos antes que se tornem incidentes.',
            },
            {
              title: 'Gestão Ágil de Acessos',
              desc: 'Realizamos ajustes pontuais de privilégios e garantimos a revogação imediata de ex-funcionários, sem travar a sua operação.',
            },
            {
              title: 'Manutenção da Conformidade',
              desc: 'Toda a administração é feita via ambiente remoto isolado, mantendo sua empresa protegida e alinhada às regras básicas de segurança.',
            },
          ],
        },
        {
          name: 'Zero Trust Blueprint (Plano Premium)',
          tagline: '',
          steps: [
            {
              title: 'Diagnóstico de Acessos',
              desc: 'Mapeamos as suas vulnerabilidades e gargalos de acesso atuais, nos bastidores, sem qualquer disrupção na rotina da sua equipa.',
            },
            {
              title: 'Automação Sem Fricção',
              desc: 'Implementamos controlos de acesso inteligentes e governança. A segurança da identidade age como um guarda-costas silencioso, protegendo os seus dados e eliminando atrasos manuais.',
            },
            {
              title: 'Produtividade Total & Conformidade',
              desc: 'A sua equipa trabalha de imediato, as suas margens ficam protegidas contra violações e o seu negócio fica pronto para auditorias.',
            },
          ],
        },
      ],
      bookingCta: 'Agendar 30 min Briefing Gratuito de Riscos de IAM',
    },
    portfolioCta: {
      eyebrow: 'Uma Perspetiva Diferente',
      headline: 'A identidade vê-se de outra forma a partir do conselho de administração.',
      body: 'Está a abordar a identidade numa perspetiva de RH ou de liderança executiva? Descubra como o método Safe-Identity liga a arquitetura de identidade à conformidade, à resiliência operacional e às prioridades do negócio.',
      cta: 'Explorar o método',
      dashboardAlt: 'Painel de governança de identidade Entra ID',
      dashboardLabel: '[ Conceito ilustrativo: Painel de Identidade e Conformidade Executiva ]',
    },
    about: {
      eyebrow: 'SOBRE N\u00D3S',
      body: 'Ancorada em mais de uma década de expertise em conformidade federal, a Pezente Digital é a consultoria estratégica especializada em IAM (Gerenciamento de Identidades e Acessos) para Azure, ajudando empresas a navegar pelas rígidas regulações da GDPR/NIS2. Entendemos os riscos financeiros que contas com privilégios excessivos e governança manual trazem para a sua operação. Como seu guia dedicado, reestruturamos seus perfis de acesso e aplicamos políticas Just-In-Time (JIT) cirúrgicas, blindando seus dados contra vulnerabilidades caras sem desacelerar o seu negócio.',
      subtitle: 'Arquitetura de Identidade Zero Trust para organiza\u00E7\u00F5es cr\u00EDticas.',
      note: 'Transformamos seu ambiente Azure em uma fortaleza de identidade segura, entregando a conformidade que o mercado europeu exige, respaldada por certificações de segurança de elite.',
    },
    contact: {
      eyebrow: 'CONTACTO',
      title: 'Vamos arquitetar a sua identidade no Azure.',
      body: 'Contacte-nos para agendar uma sess\u00E3o de consultoria confidencial. Priorizamos a seguran\u00E7a da sua identidade.',
      orWrite: 'OU ESCREVA PARA',
      region: 'EUROPE',
      practice: 'Advisory Practice \u2014 EU / EMEA',
      form: {
        name: 'NOME COMPLETO',
        email: 'E-MAIL PROFISSIONAL',
        company: 'EMPRESA',
        subject: 'ASSUNTO',
        message: 'COMO PODEMOS AJUDAR?',
        required: '* Obrigat\u00F3rio. Respondemos em at\u00E9 dois dias \u00FAteis.',
        submit: 'ENVIAR MENSAGEM',
        toastOk: 'Mensagem enviada com sucesso.',
        toastDesc: 'Responderemos dentro de dois dias \u00FAteis.',
        consentText: 'Eu consinto com o processamento dos meus dados pessoais de acordo com a',
        consentLinkText: 'Pol\u00EDtica de Privacidade',
      },
    },
    footer: {
      tagline: 'Arquitetar Identidade. Assegurar a Confian\u00E7a Digital.',
      nav: 'NAVEGA\u00C7\u00C3O',
      contact: 'CONTACTO',
      home: 'In\u00EDcio',
      about: 'Sobre N\u00F3s',
      contactLink: 'Contacto',
      advisory: 'EU / EMEA Advisory',
      billing: 'Fatura\u00E7\u00E3o e Cobran\u00E7a',
      rights: 'Todos os direitos reservados.',
      privacy: 'Privacidade',
      terms: 'Termos',
      cookiePreferences: 'Prefer\u00EAncias de Cookies',
    },
    cookies: {
      message: 'Utilizamos cookies para melhorar a sua experi\u00EAncia. Cookies n\u00E3o essenciais (como analytics) s\u00F3 s\u00E3o carregados ap\u00F3s o seu aceite. Leia a nossa',
      policyLinkText: 'Pol\u00EDtica de Privacidade',
      accept: 'Aceitar',
      reject: 'Recusar',
    },
  },
  it: {
    nav: {
      home: 'HOME',
      about: 'CHI SIAMO',
      contact: 'CONTATTO',
      cta: 'RICHIEDI CONSULENZA',
    },
    hero: {
      eyebrow: 'RIDUCI IL RISCHIO. ACCELERA L\u2019AGILIT\u00C0.',
      title1: 'Architettura Zero Trust',
      title2: 'e IAM Conforme per ambienti Azure.',
      subtitle: 'I D E N T I T À   ·   A C C E S S O   ·   G O V E R N A N C E',
      primary: 'ESPLORA I SERVIZI',
      secondary: 'CHI SIAMO',
    },
    pillars: {
      eyebrow: 'LA NOSTRA PRATICA CENTRALE',
      title: 'Tre pilastri che definiscono l\u2019identit\u00E0 aziendale.',
      items: [
        {
          title: 'Strategia Intelligente di Gestione degli Accessi',
          desc: "Previeni la fuga di dati e le minacce informatiche garantendo che ogni dipendente acceda solo a ciò che gli serve veramente—senza rallentare l'operatività quotidiana del tuo team.",
        },
        {
          title: 'Identità Digitale e Cloud Sicuro',
          desc: 'Migra al cloud in totale sicurezza e proteggi i tuoi collaboratori da remoto. Massima protezione contro gli accessi non autorizzati, in perfetta conformità con gli standard del tuo settore.',
        },
        {
          title: 'Consulenza sulla Conformità e Gestione del Rischio',
          desc: "Proteggi la tua azienda da sanzioni salatissime e ispezioni burocratiche. Semplifichiamo l'adeguamento alle normative (GDPR, NIS2) per permetterti di concentrarti sulla crescita del tuo business in totale serenità.",
        },
      ],
    },
    bridge: {
      eyebrow: "IL GRAVE COSTO DELLA GESTIONE MANUALE DEGLI ACCESSI",
      lead: "Gestire gli accessi degli utenti in modo manuale fa sprecare ore di lavoro preziose. I ritardi nell'assegnare le autorizzazioni bloccano i nuovi dipendenti, mentre la ritardata revoca delle credenziali a chi lascia l'azienda espone il tuo business a fughe di dati e sanzioni pesanti.",
      body: 'In Pezente Digital, trasformiamo la sicurezza e il controllo degli accessi in un sistema semplice e totalmente automatizzato. Riduciamo i tempi di abilitazione dei nuovi collaboratori da diversi giorni a pochi minuti. Il tuo team resta produttivo dal primo giorno, i tuoi sistemi rimangono protetti e conformi alle norme, e i tuoi margini di profitto sono al sicuro.',
      highlight: 'Sicurezza pura. Zero intoppi. La tecnologia che lavora per far crescere la tua azienda.',
    },
    threeSteps: {
      eyebrow: 'UN PERCORSO CHIARO',
      title: 'Proteggi la tua azienda senza rallentare le operazioni. Scegli il tuo metodo Safe-Identity.',
      cards: [
        {
          name: 'Gestione Continua delle Identità (Piano Base)',
          steps: [
            {
              title: 'Monitoraggio Continuo',
              desc: 'Verifichiamo regolarmente lo stato del tuo tenant (Entra ID) per identificare anomalie e rischi prima che diventino incidenti.',
            },
            {
              title: 'Gestione Agile degli Accessi',
              desc: 'Effettuiamo aggiustamenti mirati dei privilegi e garantiamo la revoca immediata degli ex dipendenti, senza bloccare la tua operatività.',
            },
            {
              title: 'Mantenimento della Conformità',
              desc: "Tutta l'amministrazione viene svolta tramite un ambiente remoto isolato, mantenendo la tua azienda protetta e allineata alle regole di sicurezza di base.",
            },
          ],
        },
        {
          name: 'Zero Trust Blueprint (Piano Premium)',
          tagline: '',
          steps: [
            {
              title: 'Valutazione degli Accessi',
              desc: 'Mappiamo le tue vulnerabilità e i colli di bottiglia negli accessi dietro le quinte, senza alcuna interruzione per la routine quotidiana del tuo team.',
            },
            {
              title: 'Automazione Senza Interruzioni',
              desc: "Implementiamo controlli di accesso intelligenti e governance. La sicurezza dell'identità agisce come una guardia del corpo silenziosa, proteggendo i tuoi dati ed eliminando i ritardi manuali.",
            },
            {
              title: 'Produttività Totale & Conformità',
              desc: 'Il tuo team lavora da subito, i tuoi margini sono protetti dalle violazioni e la tua azienda è pronta per gli audit.',
            },
          ],
        },
      ],
      bookingCta: 'Prenota un 30 min briefing gratuito sui rischi IAM',
    },
    portfolioCta: {
      eyebrow: 'Una Prospettiva Diversa',
      headline: "L'identità si vede in modo diverso dalla sala del consiglio.",
      body: "Stai affrontando il tema dell'identità da una prospettiva HR o di leadership esecutiva? Scopri come il metodo Safe-Identity collega l'architettura dell'identità alla conformità, alla resilienza operativa e alle priorità di business.",
      cta: 'Esplora il metodo',
      dashboardAlt: "Dashboard di governance dell'identità Entra ID",
      dashboardLabel: '[ Concetto illustrativo: Dashboard di Identità e Conformità Esecutiva ]',
    },
    about: {
      eyebrow: 'CHI SIAMO',
      body: 'Forte di oltre un decennio di esperienza nella conformità federale, Pezente Digital è la consulenza strategica specializzata in IAM (Identity and Access Management) per Azure, che aiuta le aziende a navigare tra le rigide normative GDPR/NIS2.. Comprendiamo i rischi finanziari che account con privilegi eccessivi e governance manuale comportano per le vostre operazioni. Come vostra guida dedicata, ristrutturiamo i ruoli di accesso e applichiamo criteri Just-In-Time (JIT) chirurgici, proteggendo i vostri dati da vulnerabilità costose senza rallentare il vostro business.',
      subtitle: 'Architettura di Identit\u00E0 Zero Trust per organizzazioni critiche.',
      note: 'Trasformiamo il vostro ambiente Azure in una fortezza di identità sicura, garantendo la conformità richiesta dal mercato europeo, supportata da certificazioni di sicurezza leader di settore.',
    },
    contact: {
      eyebrow: 'CONTATTO',
      title: 'Architettiamo la vostra identità su Azure.',
      body: 'Contattaci per pianificare una sessione di consulenza riservata. Diamo priorit\u00E0 alla sicurezza della tua identit\u00E0.',
      orWrite: 'OPPURE SCRIVI A',
      region: 'EUROPE',
      practice: 'Advisory Practice \u2014 EU / EMEA',
      form: {
        name: 'NOME COMPLETO',
        email: 'E-MAIL PROFESSIONALE',
        company: 'AZIENDA',
        subject: 'OGGETTO',
        message: 'COME POSSIAMO AIUTARTI?',
        required: '* Obbligatorio. Rispondiamo entro due giorni lavorativi.',
        submit: 'INVIA MESSAGGIO',
        toastOk: 'Messaggio inviato con successo.',
        toastDesc: 'Risponderemo entro due giorni lavorativi.',
        consentText: 'Acconsento al trattamento dei miei dati personali in conformit\u00E0 con la',
        consentLinkText: 'Informativa sulla Privacy',
      },
    },
    footer: {
      tagline: 'Progettare l\u2019Identit\u00E0. Garantire la Fiducia Digitale.',
      nav: 'NAVIGAZIONE',
      contact: 'CONTATTO',
      home: 'Home',
      about: 'Chi Siamo',
      contactLink: 'Contatto',
      advisory: 'EU / EMEA Advisory',
      billing: 'Fatturazione e Pagamenti',
      rights: 'Tutti i diritti riservati.',
      privacy: 'Privacy',
      terms: 'Termini',
      cookiePreferences: 'Preferenze Cookie',
    },
    cookies: {
      message: 'Utilizziamo cookie per migliorare la tua esperienza. I cookie non essenziali (come le analytics) vengono caricati solo dopo la tua accettazione. Leggi la nostra',
      policyLinkText: 'Informativa sulla Privacy',
      accept: 'Accetta',
      reject: 'Rifiuta',
    },
  },
};
